import { Typography } from "@mui/material";
import React from "react";

interface Props {
  amount: string;
  currencyCode: string; // 'USD' for US Dollar, 'INR' for Indian Rupee, etc.
}

const CurrencySymbol: React.FC<Props> = ({
  amount = "12345.65",
  currencyCode,
}) => {
  const inrFormatter = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  return (
    <Typography
      sx={{
        fontSize: { xl: "22px", sm: "14px", md: "16px" },
        fontWeight: 700,
      }}
    >
      <span
        style={{
          marginRight: "15px",
        }}
      >
        {" "}
        {inrFormatter.format(parseInt(amount))}
      </span>
    </Typography>
  );
};

export default CurrencySymbol;
